// extracted by mini-css-extract-plugin
export default {"image":"E3-z","loaded":"F3-z"};